import { observer } from 'mobx-react-lite';
import { Route, Switch } from 'react-router-dom';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { IndexPage } from 'src/pages/IndexPage/IndexPage';
import { RouterStore } from 'src/stores/RouterStore.ts/RouterStore';

export const RoutesLayout = observer(() => {
    return (
        <Switch>
            <Route path={RoutePaths.index} exact component={IndexPage} />
            {RouterStore.routes.map((route) => {
                return (
                    <Route
                        path={route.path}
                        exact
                        component={route.Component}
                    />
                );
            })}
            <Route path="*" />
        </Switch>
    );
});
